<script setup>
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { langUrl, closePopup, openPopup } from '@/helpers'
import { useLangStore } from '@/stores/app/lang'
import IdleTimer from '@/components/IdleTimer.vue'

const { lang } = storeToRefs(useLangStore())
const popup_closeTimeout = config.idleTimer.popup_closeTimeout * 1000

// State -----------------------------------------
const isMounted = ref(false)

// Getters ---------------------------------------

// Methods ---------------------------------------

// Events ----------------------------------------
onMounted(() => {
  isMounted.value = true
})

function onIdleTrigger_popupClose() {
  // console.log('[PopupList] onIdleTrigger_popupClose()')
  closePopup()
}

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <transition name="fade-lang">
    <div class="popup-desc" :key="lang" :lang="lang">
      <img class="title" :src="langUrl(`/images/popup/th/title-desc.png`)" />
      <div class="desc-wrapper scrollbar">
        <div class="desc" :lang="lang">
          <img :src="langUrl(`/images/popup/th/text-desc.png`)" />
        </div>
      </div>
      <img class="btn-close" :src="langUrl(`/images/popup/th/btn-close.png`, lang)" @click="closePopup()" />
      <img class="btn-list" :src="langUrl(`/images/main/th/btn-list-fans.png`)" @click="openPopup('PopupList')" />

      <Teleport to="#timer" v-if="isMounted">
        <IdleTimer
          v-if="popup_closeTimeout > 0"
          title="Popup.CloseTimeout"
          color="orange"
          :timeout="popup_closeTimeout"
          @idle-trigger="onIdleTrigger_popupClose"
        />
      </Teleport>
    </div>
  </transition>
</template>

<style scoped>
.popup-desc {
  position: absolute;
  width: 460px;
  height: 700px;
  background: url(/images/popup-bg.png) no-repeat;
}

.title {
  position: absolute;
  top: 30px;
  left: 0;
  right: 0;
  margin: auto;
}

.desc-wrapper {
  position: absolute;
  top: 110px;
  left: 40px;
  width: 380px;
  height: 460px;
  margin: 0 auto;
  text-align: center;
  overflow-y: auto;
}

.desc {
  padding-bottom: 0;
}

.desc[lang='en'] {
  padding-bottom: 15px;
}

.btn-close {
  position: absolute;
  top: 580px;
  left: 0;
  right: 0;
  margin: 0 auto;
  cursor: pointer;
}

.btn-list {
  position: absolute;
  top: 640px;
  left: 0;
  right: 0;
  margin: 0 auto;
  cursor: pointer;
}
</style>
